<template>
    <a-modal title="修改权限配置" v-model:open="open" @ok="handleOk" ok-text="提交" cancel-text="取消" class="modals">
        <a-tree checkable :tree-data="treeData"
        v-model:checkedKeys="selectedKeys"
        :fieldNames="fieldNames">
            <template #title="{ name }">
                {{ name }}
            </template>
        </a-tree>
    </a-modal>
</template>
<script>
import { updatePermissions } from '@/api/service';
import { ref } from 'vue';
import { message } from 'ant-design-vue';
export default {
    name: 'deployComponent',
    setup() {
        const open = ref(false);//是否打开
        const treeData = ref([]);//树形数据
        const id = ref('');//当前用户
        const selectedKeys = ref([]);//已选择节点
        const fieldNames = ref({key: 'id',title: 'name', children: 'children'});//节点名称
        //提交数据
        const handleOk = async () => {
            const response = await updatePermissions({selected:selectedKeys.value,id:id.value});
            if (response.code === 200) {
                message.success('添加成功');
                id.value = '';
                treeData.value = [];
                selectedKeys.value = [];
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                id.value = '';
                treeData.value = [];
                selectedKeys.value = [];
                open.value = false;
            }
        }
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }

        return {
            open,
            id,
            selectedKeys,
            treeData,
            fieldNames,
            handleOk,
            toAddCancel,
        };
    }
}
</script>